import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledTooltipComponent } from "./tooltip-component.scss";
import classnames from "classnames";
import { LIGHT_THEME } from "./tooltip-constants";
class TooltipComponent extends PureComponent {
    render() {
        const { theme, className } = this.props;
        return /*#__PURE__*/ _jsx(StyledTooltipComponent, {
            className: classnames("tooltip", theme, className),
            children: this.props.children
        });
    }
}
export { TooltipComponent as default };
TooltipComponent.defaultProps = {
    theme: LIGHT_THEME
};
